import HeroCarousel from "./components/HeroCarousel";
import DramaHighlights from "./components/DramaHighlights";
import CharacterSidebar from "./components/CharacterSidebar";
import NewsStrip from "./components/NewsStrip";
import SiteIntro from "./components/SiteIntro";
import SectionHeading from "@/components/base/SectionHeading";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function Home() {
  useDocumentTitle({
    title: "我妻子的一切 - 影视内容分享与剧情介绍",
    description:
      "我妻子的一切官网提供丰富的影视内容，涵盖剧情介绍、角色分析及影视资讯，帮助用户深入了解该剧的精彩故事。",
    keywords:
      "我妻子的一切,电视剧,剧情介绍,影视资讯,我妻子的一切剧情,我妻子的一切演员,影视分享",
  });

  return (
    <div className="w-full">
      <h1 className="sr-only">我妻子的一切 - 电视剧剧情介绍、角色分析与影视资讯分享站</h1>

      <HeroCarousel />

      <div className="w-full px-4 py-10 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <SectionHeading
              eyebrow="Story Archive"
              title="剧情介绍精选"
              description="从主线到支线，逐集梳理《我妻子的一切》的关键情节与人物动机。"
              moreTo="/category/drama"
            />
            <DramaHighlights />
          </div>
          <div className="lg:col-span-1">
            <CharacterSidebar />
          </div>
        </div>

        <div className="mt-12">
          <NewsStrip />
        </div>

        <div className="mt-12">
          <SiteIntro />
        </div>
      </div>
    </div>
  );
}